/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
import React from "react";

function KeyboardButton({
    buttonKey,
    width,
    height,
    buttonColor,
    fontSize,
    highlightColor,
    fontColor,
    clickHandler,
    aframeClasses,
    ...otherAttributes
}) {
    return (
        <a-entity class="KeyboardButton" {...otherAttributes}>
            <a-plane
                width={width}
                height={height}
                color={buttonColor}
                opacity="0.9"
            />
            <a-text
                class={aframeClasses}
                value={buttonKey.value}
                align="center"
                baseline="center"
                position="0 0 0.001"
                width={fontSize}
                height={fontSize}
                geometry={`primitive: plane; width: ${width}; height: ${height}`}
                material={`opacity: 0; transparent: true; color: ${highlightColor}`}
                color={fontColor}
                negate="true"
                onClick={() => clickHandler(buttonKey.value)}
                animation__mousedown="property: material.opacity; startEvents: mousedown; to: 0.9; dur: 100"
                animation__mouseup="property: material.opacity; startEvents: mouseup; to: 0; dur: 100"
                animation__mouseleave="property: material.opacity; startEvents: mouseleave; to: 0; dur: 100"
                animation__mouseenter="property: material.opacity; startEvents: mouseenter; to: 0.9; dur: 100"
            />
        </a-entity>
    );
}

export default KeyboardButton;
